export default {
  en: {
    title: "Privacy",
    subtitle: "Requests about what agents remember about a person, and the rules for personal data and risky content.",
    tab: { subjects: "Data subjects", pii: "Privacy and guardrails" },
    noAccess: "Your roles do not include a privacy tab.",
    subjects: {
      intro: "Look up what agents remember about a person, export it, or erase it (right to erasure). Ask the person for their user ID: they can copy it from the account menu.",
      subject: "User ID (subject)",
      lookup: "Look up",
      items: "Memory items",
      consents: "Consents",
      erasures: "Past erasures",
      kind: "Kind",
      agent: "Agent",
      content: "Content",
      created: "Created",
      purpose: "Purpose",
      granted: "Granted",
      revoked: "Revoked",
      active: "Active",
      erasureId: "Erasure ID",
      erasedAt: "Erased",
      total: "Items erased",
      export: "Export (JSON)",
      erase: "Erase all memories",
      eraseTitle: "Erase all memories of {{subject}}",
      eraseBody: "Every memory item about this person is hard-deleted, their consents are revoked and a signed erasure certificate is issued. This cannot be undone.",
      typeToConfirm: "Type {{subject}} to confirm",
      erased: "Memories erased: {{total}} items",
      certificate: "Erasure certificate",
      counts: "Items per kind",
      consentsRevoked: "Consents revoked",
      subjectSha: "Subject (SHA-256)",
      idsSha: "Deleted IDs (SHA-256)",
      signature: "Signing key",
      downloadCertificate: "Download certificate",
      kinds: { working: "Working", episodic: "Episodic", semantic: "Semantic", procedural: "Procedural" },
      none: "—",
    },
    pii: {
      intro: "Effective guardrail rules for your organisation. Saving creates a new, audited organisation layer on top of the platform defaults; agent-level overrides stay in the API.",
      direction: { input: "Input (before the model)", output: "Output (before the answer leaves)" },
      category: "Category",
      action: "Action",
      threshold: "Threshold",
      selfCheck: "LLM self-check",
      categories: { pii: "Personal data (PII)", secret: "Secrets", prompt_injection: "Prompt injection", unsafe_action: "Unsafe action", toxicity: "Toxicity" },
      actions: { block: "Block", redact: "Redact", flag: "Flag", off: "Off" },
      save: "Save rules",
      saved: "PII rules saved (version {{version}})",
      history: "History",
      version: "Version",
      digest: "Digest",
      by: "Changed by",
      at: "Changed",
      effective: "Effective version {{version}}",
    },
    issues: {
      redact_only_pii_secret: "Redact is only available for personal data and secrets.",
      threshold_range: "Thresholds must be between 0 and 1.",
    },
  },
  ar: {
    title: "الخصوصية",
    subtitle: "طلبات الأشخاص حول ما تتذكره الوكلاء عنهم، وقواعد البيانات الشخصية والمحتوى الخطر.",
    tab: { subjects: "أصحاب البيانات", pii: "الخصوصية والضوابط الوقائية" },
    noAccess: "أدوارك لا تتضمن أي تبويب للخصوصية.",
    subjects: {
      intro: "اعرض ما تتذكره الوكلاء عن شخص ما أو صدّره أو امحه (الحق في المحو). اطلب من الشخص معرّف المستخدم الخاص به، ويمكنه نسخه من قائمة الحساب.",
      subject: "معرّف المستخدم (صاحب البيانات)",
      lookup: "بحث",
      items: "عناصر الذاكرة",
      consents: "الموافقات",
      erasures: "عمليات المحو السابقة",
      kind: "النوع",
      agent: "الوكيل",
      content: "المحتوى",
      created: "تاريخ الإنشاء",
      purpose: "الغرض",
      granted: "تاريخ المنح",
      revoked: "تاريخ السحب",
      active: "سارية",
      erasureId: "معرّف المحو",
      erasedAt: "تاريخ المحو",
      total: "العناصر الممحوة",
      export: "تصدير (JSON)",
      erase: "محو كل الذكريات",
      eraseTitle: "محو كل ذكريات {{subject}}",
      eraseBody: "تُحذف جميع عناصر الذاكرة المتعلقة بهذا الشخص نهائيًا، وتُسحب موافقاته، وتصدر شهادة محو موقّعة. لا يمكن التراجع عن ذلك.",
      typeToConfirm: "اكتب {{subject}} للتأكيد",
      erased: "تم محو الذكريات: {{total}} عنصر",
      certificate: "شهادة المحو",
      counts: "العناصر حسب النوع",
      consentsRevoked: "الموافقات المسحوبة",
      subjectSha: "صاحب البيانات (SHA-256)",
      idsSha: "المعرّفات المحذوفة (SHA-256)",
      signature: "مفتاح التوقيع",
      downloadCertificate: "تنزيل الشهادة",
      kinds: { working: "عاملة", episodic: "حدثية", semantic: "دلالية", procedural: "إجرائية" },
      none: "—",
    },
    pii: {
      intro: "قواعد الضوابط السارية على جهتك. يُنشئ الحفظ طبقة جديدة مدقَّقة للجهة فوق إعدادات المنصة الافتراضية، وتبقى استثناءات الوكلاء عبر الواجهة البرمجية.",
      direction: { input: "المدخلات (قبل النموذج)", output: "المخرجات (قبل خروج الإجابة)" },
      category: "الفئة",
      action: "الإجراء",
      threshold: "العتبة",
      selfCheck: "الفحص الذاتي بالنموذج اللغوي",
      categories: { pii: "البيانات الشخصية", secret: "الأسرار", prompt_injection: "حقن التعليمات", unsafe_action: "إجراء غير آمن", toxicity: "المحتوى المسيء" },
      actions: { block: "حظر", redact: "إخفاء", flag: "تنبيه", off: "إيقاف" },
      save: "حفظ القواعد",
      saved: "تم حفظ قواعد البيانات الشخصية (الإصدار {{version}})",
      history: "السجل",
      version: "الإصدار",
      digest: "البصمة",
      by: "عدّلها",
      at: "تاريخ التعديل",
      effective: "الإصدار الساري {{version}}",
    },
    issues: {
      redact_only_pii_secret: "الإخفاء متاح للبيانات الشخصية والأسرار فقط.",
      threshold_range: "يجب أن تكون العتبات بين 0 و1.",
    },
  },
};
